/* eslint-disable react/no-array-index-key */
import React, { useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import { TextItem, ImageChooser } from '@bingads-webui-campaign-react/asset-library-creative-components';
import {
  DefaultButton,
} from '@bingads-webui-react/fabric-control';

export const MetaDataEditor = ({
  metaData,
  i18n,
  cid,
  aid,
  oDataConfig,
  finalUrl,
  assetLibraryConfig,
  onTextListChange,
  onChangeImage,
  disableGenerate,
  handleGenerate,
  textErrorMessages,
}) => {
  const [textList, setTextList] = React.useState();

  const onTextListUpdate = useCallback((str, index) => {
    const newTextList = [...textList];
    newTextList[index] = str;
    setTextList(newTextList);
    onTextListChange(newTextList);
  }, [onTextListChange, textList]);

  useEffect(() => {
    if (metaData && metaData.text && metaData.images) {
      setTextList(metaData.text);
    }
  }, [metaData]);

  const imageSrc = useMemo(() => (metaData && metaData.newImage && metaData.newImage.url) || '', [metaData]);

  return (
    <div className="meta-data-editor">
      {
        textList && textList.length > 0 && textList.map((text, index) => (
          <div key={index}>
            <TextItem
              i18n={i18n}
              text={text}
              updateText={(str) => { onTextListUpdate(str, index); }}
              errorMessage={(textErrorMessages && textErrorMessages[index]) || ''}
              title={i18n.getString(_TL_('Text {{index}}'), { index: index + 1 })}
              showHelpPopup
              helpTopic="pop_BA_VideoAdsCopilot_Text"
            />
          </div>
        ))
      }
      {
        imageSrc &&
        <ImageChooser
          currentImage={imageSrc}
          cid={cid}
          aid={aid}
          oDataConfig={oDataConfig}
          finalUrl={finalUrl}
          onChangeImage={onChangeImage}
          assetLibraryConfig={assetLibraryConfig}
          i18n={i18n}
          showHelpPopup
          helpTopic="pop_BA_VideoAdsCopilot_Image"
        />
      }
      <DefaultButton
        styles={{ root: { marginTop: '24px' } }}
        iconProps={{ iconName: 'Send' }}
        onClick={handleGenerate}
        className="generate-video-button"
        text={i18n.getString(_TL_('Generate'))}
        disabled={disableGenerate}
      />
    </div>
  );
};

MetaDataEditor.propTypes = {
  metaData: PropTypes.shape({
    text: PropTypes.arrayOf(PropTypes.string),
    images: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  i18n: PropTypes.shape({}).isRequired,
  cid: PropTypes.string.isRequired,
  aid: PropTypes.string.isRequired,
  oDataConfig: PropTypes.shape({}).isRequired,
  finalUrl: PropTypes.string.isRequired,
  assetLibraryConfig: PropTypes.shape({}).isRequired,
  onChangeImage: PropTypes.func.isRequired,
  onTextListChange: PropTypes.func.isRequired,
  disableGenerate: PropTypes.bool.isRequired,
  handleGenerate: PropTypes.func.isRequired,
  textErrorMessages: PropTypes.arrayOf(PropTypes.string),
};

MetaDataEditor.defaultProps = {
  textErrorMessages: undefined,
};
